module.exports = __webpack_public_path__ + "img/Frame 1064three.f2f78569.png";